<template>
  <div>
    <v-layout wrap v-if="!isFoundCaseA" class="red--text">
      <v-flex xs1>
        <v-icon color="red">warning</v-icon>
      </v-flex>
      <v-flex xs3 class="pa-1">{{value.caseA}}</v-flex>
      <v-flex xs4 class="pa-1">{{symbolized.name}}</v-flex>
      <v-flex xs3 class="pa-1">
        <div class="form-control">{{this.value.caseB}}</div>
      </v-flex>
      <v-flex xs1>
        <v-btn fab small depressed color="primary" @click="$emit('onDelete')">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap v-else>
      <v-flex xs4 class="pa-1">
        <div class="form-control">
          <multiselect
            v-model="caseA"
            :options="filterVariable"
            :searchable="true"
            track-by="name"
            label="name"
            @input="onChangeCaseA"
          ></multiselect>
        </div>
      </v-flex>

      <v-flex xs4 class="pa-1">
        <multiselect
          v-model="symbolized"
          :options="symbolOption"
          :allow-empty="false"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          track-by="name"
          label="name"
          @input="onChangeSymbol"
        ></multiselect>
      </v-flex>
      <v-flex xs3 class="pa-1">
        <div
          class="form-control"
          :class="{ 'has-error': errors.has('caseB') }"
          v-if="caseA != '' && caseA != null"
        >
          <dynamic-case-b-manage
            :key="caseA.value"
            v-model="caseB"
            :datatype="caseA.value"
            @onChange="onChangeCaseB"
          ></dynamic-case-b-manage>
          <input
            name="caseB"
            type="hidden"
            v-model="caseB"
            data-vv-as="Case B"
            v-validate="'required'"
          />
        </div>
      </v-flex>
      <v-flex xs1>
        <v-btn fab small depressed color="primary" @click="$emit('onDelete')">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters, mapMutations } from 'vuex'
import DynamicCaseBManage from './DynamicCaseBManage'
export default {
  props: ['value'],
  inject: ['$validator'],
  data() {
    return {
      caseA: '',
      caseB: '',
      symbolized: '',
      symbolOption: [
        {
          name: 'EQUAL TO',
          value: '=='
        },
        {
          name: 'NOT EQUAL TO',
          value: '!='
        },
        {
          name: 'GREATER THAN OR EQUAL TO',
          value: '>='
        },
        {
          name: 'LESS THAN OR EQUAL TO',
          value: '<='
        },
        {
          name: 'LESS THAN',
          value: '<'
        },
        {
          name: 'GREATER THAN',
          value: '>'
        }
      ],
      isFoundCaseA: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    filterVariable() {
      var vm = this
      var variable = []
      if (vm.variable) {
        variable = vm.variable.filter(el => {
          return el.flowid == 0 || (vm.selectedFlow && el.flowid == vm.selectedFlow.id)
        })
      }
      var result = []
      variable.map(el => {
        result.push({
          name: el.name,
          value: el.name
        })
      })
      return result
    }
  },
  components: {
    Multiselect,
    DynamicCaseBManage
  },
  mounted() {
    if (this.value) {
      var caseA = this.filterVariable.find(el => {
        return '{' + el.name + '}' == this.value.caseA
      })
      this.caseA = caseA ? caseA : null
      this.isFoundCaseA = !(
        this.caseA == null &&
        this.value.caseA != '' &&
        this.value.caseA != null
      )
      this.caseB = this.value.caseB
      var symbolized = this.symbolOption.find(el => {
        return el.value == this.value.symbol
      })
      this.symbolized = symbolized ? symbolized : null
    } else {
      this.symbolized = this.symbolOption[0]
      this.caseA =
        this.filterVariable && this.filterVariable.length > 0 ? this.filterVariable[0] : null
    }
  },
  methods: {
    onChangeCaseA(val) {
      this.caseB = null

      var data = {
        caseA: `{${val.name}}`,
        caseB: this.caseB && typeof this.caseB == 'string' ? this.caseB.trim() : '',
        symbol: this.symbolized.value
      }
      this.$emit('input', data)
    },
    onChangeSymbol(val) {
      var data = {
        caseA: `{${this.caseA.name}}`,
        caseB: this.caseB && typeof this.caseB == 'string' ? this.caseB.trim() : '',
        symbol: val.value
      }
      this.$emit('input', data)
    },
    onChangeCaseB() {
      var data = {
        caseA: `{${this.caseA.name}}`,
        caseB: this.caseB && typeof this.caseB == 'string' ? this.caseB.trim() : '',
        symbol: this.symbolized.value
      }
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/flow/CaseConditionManage.vue